import { Flight } from '../types';
import { csvEscape, csvEscapeRaw } from './csvSafe';
import { DateFormat } from './DateFormat';

const HEADERS = [
  'Дата полёта',
  'Пилот',
  'Тахометр',
  'Моточасы',
  'Тип полёта',
  'Посадки',
  'Топливо',
  'Где залито',
  'Масло',
  'Расход л',
  'Стоимость руб',
  'Неисправность',
] as const;

/**
 * Дата как текстовая формула Excel: ="ДД.ММ.ГГГГ".
 * Иначе Excel делает из неё «дату-число» и при узкой колонке рисует ######.
 */
function asDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '';
  const d = DateFormat(String(dateStr), 'dot');
  return `="${d}"`;
}

function asDecimal(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return String(n).replace('.', ',');
}

function asInt(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return String(Math.trunc(n));
}

function asText(value: string | null | undefined): string {
  if (value == null) return '';
  return String(value);
}

function rowValues(f: Flight): string[] {
  return [
    csvEscapeRaw(asDate(String(f.date))),
    csvEscape(asText(f.pilot)),
    csvEscapeRaw(asDecimal(f.hobbs_end)),
    csvEscapeRaw(asDecimal(f.hours)),
    csvEscape(asText(f.flight_type || 'По кругам')),
    csvEscapeRaw(asInt(f.landings ?? 0)),
    csvEscapeRaw(asDecimal(f.fuel)),
    csvEscape(asText(f.fuel_location)),
    csvEscapeRaw(asDecimal(f.oil)),
    csvEscapeRaw(asDecimal(f.fuel_used_liters)),
    csvEscapeRaw(asDecimal(f.fuel_cost)),
    csvEscape(asText(f.issue)),
  ];
}

/** CSV с `;` и BOM — нормально открывается в Excel (RU). */
export function buildFlightsCsv(flights: Flight[]): string {
  const lines = [
    HEADERS.join(';'),
    ...flights.map((f) => rowValues(f).join(';')),
  ];
  return `\uFEFF${lines.join('\r\n')}\r\n`;
}

export function downloadFlightsCsv(
  flights: Flight[],
  filenameBase = 'flights'
): void {
  const csv = buildFlightsCsv(flights);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${filenameBase}-${stamp}.csv`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
